// extracted by mini-css-extract-plugin
export default {"skeletonModule":"Skeleton_skeletonModule__mUYG1","pulse":"Skeleton_pulse__lK-DZ"};